import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  useCallback,
} from "react";
import { getRegisterlist, getproducttypelist } from "./../../services/wms";

import DatePicker from "react-datepicker";
import { Link } from "react-router-dom";
import moment from "moment";
import BranchContext from "./../context/branch";
import Input from "./../wms/input";
import Renderregister from "./renderregisterlist";
import Header from "./headerlist";
import ScrollToTop from "../common/ScrollToTop";
const Registerlist = (props) => {
  let datalink = props.location.linkdetails;
  let cusId = 0;
  //console.log(datalink);
  if (datalink) {
    cusId = datalink.cusid;
  }
  //console.log(cusId);http://wms.advanceagro.net/wsface/api/face/RealImage?IdentityID=

  const { currentBranch } = useContext(BranchContext);

  const [register, setregister] = useState([]);
  const [producttypelist, setproducttypelist] = useState([]);
  const [producttypeid, setproducttypeid] = useState(0);
  const [cusid, setCusid] = useState(cusId);
  const [search, setSearch] = useState("");
  const [name, setname] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [vForm, setvForm] = useState(false);
  const [endDate, setEndDate] = useState(new Date());
  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [onProgress, setonProgress] = useState(false);
  const [pageSize, setPageSize] = useState(25);

  useEffect(() => {
    if (vForm) return;
    const getLinkdata = () => {
      if (datalink && !vForm) {
        const queuedate = new Date(datalink.ddate);
        // if (datalink.cusid) {
        setvForm(true);
        //  }

        setStartDate(queuedate);
        setEndDate(queuedate);
        setCusid(datalink.cusid);

        //  console.log(queuedate);
      } else {
        setvForm(true);
      }
    };
    getLinkdata();
  });
  useEffect(() => {
    if (onProgress) return;

    setregister([]);
  }, [
    vForm,
    startDate,
    endDate,
    currentBranch,
    search,
    cusid,
    pageSize,
    onProgress,producttypeid
  ]);
  //console.log("List",register)

  
  useEffect(() => {
    if (!vForm) return;
    if (!currentBranch) return;
    if (!currentBranch._id) return;
    if (onProgress) return;
    setLoading(true);
    setError(false);
    getRegisterlist(
      moment(startDate, "YYYY-MM-DD").add(0, "day").format("YYYY-MM-DD"),
      moment(endDate, "YYYY-MM-DD").add(0, "day").format("YYYY-MM-DD"),
      currentBranch && currentBranch._id,
      cusid,
      search,
      pageSize,
      pageNumber,producttypeid
    ).then((result) => {
      //console.log("test",result.data);
      setregister((prevData) => {
        return [...new Set([...prevData, ...result.data])];
      });
      setHasMore(result.data.length > pageSize - 1);
      setLoading(false);

      // setregister(result.data);
    });
  }, [
    vForm,
    startDate,
    endDate,
    currentBranch,
    search,
    cusid,
    pageSize,
    pageNumber,
    onProgress,producttypeid
  ]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!currentBranch._id) return;
    const loadData = async () => {
      try {
        const { data: result } = await getproducttypelist(currentBranch && currentBranch._id);
        if (result.status === "success") {
          setproducttypelist(result.data.list);
        }
      } catch (ex) {
        // toast.error(ex.message);
      }
    };
    loadData();
  }, [currentBranch]);
  const handleOnProgress = (event) => {
    setonProgress(event);
  };
  const handleChangStartDate = (event) => {
    setStartDate(event);
    setPageNumber(1);
  };
  const handleChangEndDate = (event) => {
    setEndDate(event);
    setPageNumber(1);
  };
  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        //  console.log(entries[0].isIntersecting,hasMore);

        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  const handleChangeSelect = ({ name, item, classname }) => {
    const clear = [...producttypelist];

    const index1 = clear.findIndex((x) => x.classname === "btn btn-primary");
    if (index1 > -1) {
      clear[index1].classname = "btn btn-outline-dark";
      setproducttypelist(clear);
    }
    const subobject = {
      _id: item,
      name: name,
      classname: "btn btn-primary",
    };
    const sub = [...producttypelist];
    const index = sub.findIndex((x) => x._id === item);
    sub[index] = subobject;
    setproducttypelist(sub);
    setproducttypeid(item)
    setPageNumber(1);
  };

  const handleTextchange = (event) => {
    setname(event.target.value);
    // setPageNumber(1);
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      setSearch(name);
      setPageNumber(1);
    }
  };
  const handleSearchDrinvenClick = () => {
    setSearch(name);
    setPageNumber(1);
  };
  if (!vForm) {
    return <div></div>;
  }
  // if (currentBranch._id == "vms") {
  //   return <></>;
  // }

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="row col-auto">
            <div className="col-auto">
              <div className="">
                <p>
                  จากวันที่ <span className="label"></span>
                </p>

                <div className="">
                  <DatePicker
                    className="datepicker-default form-control"
                    todayButton="Today"
                    dateFormat="dd/MM/yyyy"
                    selected={startDate}
                    onChange={handleChangStartDate}
                  />
                </div>
              </div>
            </div>
            <div className="col-auto">
              <div className="">
                <p>
                  ถึงวันที่ <span className="label"></span>
                </p>
                <div className="">
                  <DatePicker
                    className="datepicker-default form-control"
                    todayButton="Today"
                    dateFormat="dd/MM/yyyy"
                    selected={endDate}
                    onChange={handleChangEndDate}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row col-auto">
            <div className="col-auto mt-3">
              <div className="form-group">
                <Input
                  name="weightno"
                  value={name}
                  placeholder="ทะเบียนรถ เลขที่ใบชั่ง"
                  onChange={handleTextchange}
                  onKeyPress={handleKeyPress}
                  onClick={handleSearchDrinvenClick}
                  search="ค้นหา"
                />
              </div>
            </div>

            <div className="col-auto mt-3">
              <div>&nbsp;</div>
              <button className="btn btn-success ">Download To Excel</button>
            </div>
          </div>
        </div>

        <div className="col-auto mt-1">
          <p className="text-primary">
            กลุ่มสินค้า <span className="label label-default"></span>
          </p>
          <div className="mt-1">
            <Header
              list={producttypelist}
              onChange={handleChangeSelect}
              disabled={loading}
            />
          </div>
        </div>
        <p className="text-success">
          แสดงข้อมูล {register ? register.length : 0} รายการ บนระบบ
        </p>
  

        {<ScrollToTop />}

        <Renderregister
          list={register}
          loading={loading}
          onProcess={handleOnProgress}
          error={error}
          lastBookElementRef={lastBookElementRef}
        />

        <div>{loading && "Loading..."}</div>
        <div>{error && "Error"}</div>
      </div>
    </>
  );
};

export default Registerlist;
